var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentOneClickDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9597 17.8375L19.3297 18.3875C18.8797 18.5375 18.5197 18.8875 18.3697 19.3475L17.8197 20.9775C17.3497 22.3875 15.3697 22.3575 14.9297 20.9475L13.0797 14.9975C12.7197 13.8175 13.8097 12.7175 14.9797 13.0875L20.9397 14.9375C22.3397 15.3775 22.3597 17.3675 20.9597 17.8375Z",
    fill: "#758295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5015C20 11.8862 19.9732 12.2708 19.9284 12.6465C19.8927 12.9149 19.6153 13.0759 19.3559 12.9954L15.0172 11.6446C14.5479 11.4984 14.0476 11.4827 13.57 11.5993C13.0924 11.716 12.6557 11.9605 12.3066 12.3066C11.5909 13.0223 11.3315 14.0689 11.6357 15.0351L12.9775 19.3559C13.0581 19.6153 12.8881 19.8927 12.6197 19.9284C12.244 19.9732 11.8772 20 11.5015 20C6.72443 20 2.87773 16.0728 3.00297 11.2599C3.12822 6.82283 6.82283 3.12822 11.2599 3.00297C16.0728 2.87773 20 6.72443 20 11.5015Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentOneClickDisabled);
export default __webpack_public_path__ + "static/media/shipment_one_click_disabled.fe2c9086f2c0b564a67a1d6555515c4e.svg";
export { ForwardRef as ReactComponent };